import { FC, useState } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Tooltip, TooltipProps } from '@shared/components/tooltip';

import { styles } from './TruncatedTooltip.styles';

export interface TruncatedTooltipProps extends Pick<TooltipProps, 'delay' | 'placement'>, WithStyles<typeof styles> {
  text: string;
}

const TruncatedTooltipComponent: FC<TruncatedTooltipProps> = ({ classes, delay, placement, text }) => {
  const [isTruncated, setIsTruncated] = useState(false);

  return (
    <Tooltip delay={delay} placement={placement} title={isTruncated ? text : ''}>
      <span
        className={classes.root}
        // Measured on hover rather than on render so it reflects the current width without a resize listener.
        onMouseEnter={({ currentTarget: { clientHeight, clientWidth, scrollHeight, scrollWidth } }) =>
          setIsTruncated(scrollHeight > clientHeight || scrollWidth > clientWidth)
        }
      >
        {text}
      </span>
    </Tooltip>
  );
};

export const TruncatedTooltip = withStyles(styles)(TruncatedTooltipComponent);
